<template>
  <div>
    <b-modal id="upload-file-modal" title="Carica file" centered>
      <div class="spinner-area" v-if="elementsLoading">
        <b-spinner label="Spinning"></b-spinner>
      </div>
      <form :class="{ hide: elementsLoading }">
        <div class="form-group">
          <div class="row">
            <div class="col-6">
              <label for="">Nome file</label>
              <input type="text" class="form-control" v-model="name" />
            </div>
            <div class="col-6">
              <label for="">Tag</label>
              <select class="form-control" v-model="tag">
                <option value="null">Seleziona tag...</option>
                <option
                  :value="tag.uuid"
                  v-for="(tag, index) in tags"
                  :key="index"
                >
                  {{ tag.value }}
                </option>
              </select>
              <small class="add-element" @click="openAddElementDialog('tag')">
                Aggiungi tag
              </small>
            </div>
          </div>

          <div class="row mt-3">
            <div class="col-6">
              <label for="">Tipologia file</label>
              <select class="form-control" v-model="fileType">
                <option value="null">Seleziona tipologia file...</option>
                <option
                  :value="fileType.uuid"
                  v-for="(fileType, index) in fileTypes"
                  :key="index"
                >
                  {{ fileType.value }}
                </option>
              </select>
              <!-- <small class="add-element" @click="openAddElementDialog('type')">
                Aggiungi tipologia
              </small> -->
            </div>
            <div class="col-6">
              <label for="">Categoria</label>
              <select class="form-control" v-model="category">
                <option value="null">Seleziona categoria...</option>
                <option
                  :value="category.uuid"
                  v-for="(category, index) in categories"
                  :key="index"
                >
                  {{ category.value }}
                </option>
              </select>
              <small
                class="add-element"
                @click="openAddElementDialog('category')"
              >
                Aggiungi categoria
              </small>
            </div>
          </div>

          <div class="row mt-3">
            <div class="col-6">
              <label for="">Anno</label>
              <select class="form-control" v-model="year">
                <option value="null">Seleziona tipologia file...</option>
                <option
                  :value="year.uuid"
                  v-for="(year, index) in years"
                  :key="index"
                >
                  {{ year.value }}
                </option>
              </select>
              <small class="add-element" @click="openAddElementDialog('year')">
                Aggiungi anno
              </small>
            </div>
            <div class="col-6">
              <label for="">Brand</label>
              <select class="form-control" v-model="brand">
                <option value="null">Seleziona brand...</option>
                <option
                  :value="brand.uuid"
                  v-for="(brand, index) in brands"
                  :key="index"
                >
                  {{ brand.value }}
                </option>
              </select>
              <small class="add-element" @click="openAddElementDialog('brand')">
                Aggiungi brand
              </small>
            </div>
          </div>

          <div class="row mt-3">
            <div class="col-12">
              <label for="">Descrizione</label>
              <textarea
                cols="30"
                rows="5"
                class="form-control"
                v-model="description"
              ></textarea>
            </div>
          </div>

          <div class="row mt-3">
            <div class="col-12">
              <label for="">File</label>
              <input
                class="form-control"
                type="file"
                id="file-input"
                @change="saveFile"
                multiple
              />
            </div>
          </div>

          <div class="row mt-3">
            <div class="col-12">
              <label for="">Miniatura</label>
              <input
                class="form-control"
                type="file"
                id="thumb-input"
                @change="saveThumb"
              />
            </div>
          </div>
        </div>
      </form>

      <template #modal-footer>
        <div class="w-100">
          <LoadingButton
            :text="ctaText"
            :classes="['btn-primary', 'w-100']"
            :loading="loading"
            :disabled="
              $v.$invalid ||
              !category ||
              !fileType ||
              !year ||
              !brand ||
              !tag ||
              !files.length
            "
            @click="storeFile()"
          />
        </div>
      </template>
    </b-modal>

    <AddElementDialog
      :title="'Aggiungi elemento'"
      :size="'sm'"
      @add="addElement($event)"
    />
  </div>
</template>

<script>
import { required } from "vuelidate/lib/validators";
import UploaderService from "@/services/uploader";
import FilesService from "@/services/files";

import TagsService from "@/services/tags";
import FileTypesService from "@/services/file-types";
import BrandsService from "@/services/brands";
import CategoriesService from "@/services/categories";
import YearsService from "@/services/years";

export default {
  props: ["fileTypes", "categories", "years", "brands", "tags"],
  data() {
    return {
      ctaText: "Carica file",
      name: "",
      description: "",
      loading: false,
      category: null,
      fileType: null,
      year: null,
      brand: null,
      tag: null,
      files: [],
      thumbs: [],
      fileUrls: [],
      element: null,
      elementsLoading: false,
    };
  },
  validations: {
    name: {
      required,
    },
  },
  methods: {
    saveFile(event) {
      this.files = event.target.files;
    },

    saveThumb(event) {
      this.thumbs = event.target.files;
    },

    async storeFile() {
      this.loading = true;

      const fileUrls = await UploaderService.uploadFile(
        this.files,
        this.fileType
      );

      this.fileUrls = fileUrls;

      for (const url of fileUrls) {
        this.createNewFile(url);
      }
    },

    async createNewFile(url) {
      const file = this.files[this.fileUrls.indexOf(url)];
      const ext = file.name.split(".").pop();

      const body = {
        fileName: this.name,
        description: this.description,
        brand: this.getBrand(),
        tag: this.getTag(),
        category: this.getCategory(),
        fileType: this.getFileType(),
        year: this.getYear(),
        url,
        ext,
      };

      // Upload Thumbnail
      if (this.thumbs.length) {
        const thumbUrls = await UploaderService.uploadFile(
          this.thumbs,
          'thumbnail'
        );

        body.thumbnail = thumbUrls[0];
      }

      await FilesService.addFile(this.$db, body);

      this.loading = false;

      this.$emit("uploaded", true);
      this.$root.$emit("bv::hide::modal", "upload-file-modal");
    },

    getCategory() {
      return this.categories.find(
        (category) => category.uuid === this.category
      );
    },

    getFileType() {
      const fileType = this.fileTypes.find(
        (fileType) => fileType.uuid === this.fileType
      );

      return {
        uuid: fileType.uuid,
        value: fileType.value,
      };
    },

    getYear() {
      return this.years.find((year) => year.uuid === this.year);
    },

    getBrand() {
      return this.brands.find((brand) => brand.uuid === this.brand);
    },

    getTag() {
      return this.tags.find((tag) => tag.uuid === this.tag);
    },

    openAddElementDialog(element) {
      this.element = element;
      this.$root.$emit("bv::show::modal", "add-element-modal");
    },

    async addElement(element) {
      this.elementsLoading = true;
      this.$root.$emit("bv::hide::modal", "add-element-modal");

      switch (this.element) {
        case "tag": {
          try {
            await TagsService.addTag(this.$db, element);
          } catch (error) {
            this.$toast.error(error.message);
          } finally {
            this.elementsLoading = false;
          }
          break;
        }
        case "type": {
          try {
            await FileTypesService.addFileType(this.$db, element);
          } catch (error) {
            this.$toast.error(error.message);
          } finally {
            this.elementsLoading = false;
          }
          break;
        }
        case "category": {
          try {
            await CategoriesService.addCategory(this.$db, element);
          } catch (error) {
            this.$toast.error(error.message);
          } finally {
            this.elementsLoading = false;
          }
          break;
        }
        case "year": {
          try {
            await YearsService.addYear(this.$db, element);
          } catch (error) {
            this.$toast.error(error.message);
          } finally {
            this.elementsLoading = false;
          }
          break;
        }
        case "brand": {
          try {
            await BrandsService.addBrand(this.$db, element);
          } catch (error) {
            this.$toast.error(error.message);
          } finally {
            this.elementsLoading = false;
          }
          break;
        }
      }

      this.$emit("newElement", this.element);
    },
  },
};
</script>

<style scoped>
.add-element {
  text-decoration: underline;
  cursor: pointer;
}

.hide {
  opacity: 0;
}

.spinner-area {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
</style>



// WEBPACK FOOTER //
// src/components/shared/UploadFileDialog.vue